// dist/template-parts/js/woocommerce/product-biomarkers-list.js
(function () {
  const root = document.querySelector(".nlp-biomarkers");
  if (!root || root.dataset.init === "1") return;
  root.dataset.init = "1";

  const gsap = window.gsap;
  if (!gsap) return;

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) return;

  if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

  const kicker = root.querySelector(".nlp-biomarkers__kicker");
  const logos = root.querySelector(".nlp-biomarkers__logos");
  const headline = root.querySelector(".nlp-biomarkers__headline");
  const list = root.querySelector(".nlp-biomarkers__list");

  const targets = [kicker, logos, headline, list].filter(Boolean);
  if (!targets.length) return;

  gsap.set(targets, { opacity: 0, y: 18 });

  gsap.to(targets, {
    opacity: 1,
    y: 0,
    duration: 0.9,
    ease: "power2.out",
    stagger: 0.08,
    scrollTrigger: window.ScrollTrigger
      ? { trigger: root, start: "top 85%", once: true }
      : undefined,
  });
})();
